import React, { useState, useEffect } from 'react'
import { styled } from '@mui/material/styles'
import PropTypes from 'prop-types'
import { Button, CardContent, CircularProgress, Typography } from '@mui/material'
import { TextInput, Form, required, useLogin, useNotify  } from 'react-admin'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import useCustomTranslate from 'src/hooks/useCustomTranslate' 
import FingerprintJS from '@fingerprintjs/fingerprintjs'

const DEVICE_NOT_FOUND = 'ra.auth.device_not_found'
const DEVICE_CODE_INVLID = 'ra.auth.device_code_invalid'
const USER_DISBLE = 'ra.auth.user_disabled'
const RESET_PASSWORD_USER = 'ra.auth.reset_password'
const DEVICE_WITH_EXPIRED_SESSION = 'ra.auth.device_with_expired_session'
const EXPIRED_CODE = "ra.auth.device_code_expired"
const DEFAULT_MSG = 'ra.auth.sign_in_error'
const INVALID_CODE = 'ra.auth.device_code_invalid'

export const LoginForm = (props: LoginFormProps) => {
  const { className } = props
  const [formKey, setFormKey] = useState(0)
  const [loading, setLoading] = useState(false)
  const [multipleClient, setMultipleClient] = useState(false)
  const [userData, setUserData] = useState<any>({})
  const [clients, setClients] = useState<any[]>([])
  const [showDeviceCodeField, setShowDeviceCodeField] = useState(false)
  const [fingerprint, setFingerprint] = useState('')
  const login = useLogin()
  const notify = useNotify()

  const { translate, changeLanguage } = useCustomTranslate()


  useEffect(() => {
    const loadFingerprint = async () => {
      const fp = await FingerprintJS.load()
      const result = await fp.get()
      setFingerprint(result.visitorId) 
    }
    loadFingerprint()
  }, [])

  const getClientsFromUser = async (params: any,visitorId:any) => {
    /* try { */
      let URL = `${process.env.REACT_APP_URL_AUTH}/login-web`
      const request = new Request(URL, {
        method: 'POST',
        body: JSON.stringify({
          user: params.username,
          pass: params.password,
          ...(params.device_code && { device_code:params.device_code })
        }),
        headers: new Headers({
          'Content-Type': 'application/json',
          ...(visitorId && { 'Visitor-Id': visitorId }),
        }),
      })
      const response = await fetch(request)
      /* if (response.status < 200 || response.status >= 300) {
        throw new Error(response.statusText)
      } */
      const data = await response.json()
      if (!response.ok) {
        if (data?.exception) {
          throw new Error(data?.exception) //throw new Error(data?.exception) // Lanza una excepción específica
        }
        throw new Error(data?.message || 'Login failed') // Otros errores
      }
      
      const length_clients = data?.clients?.length

      const state = (length_clients: number | undefined) => {
        if (length_clients !== undefined && length_clients !== null && length_clients === 1) {
          return false
        }
        if (length_clients !== undefined && length_clients !== null && length_clients > 1) {
          return true
        }
        return null
      }

      localStorage.setItem('language', data?.user?.language || 'es-AR')
      changeLanguage(data?.user?.language || 'es-AR')

      return {
        clients:data.clients,
        more_of_one: state(length_clients),
      }
    /* } catch (error: any) {
      setLoading(false)
      notifyError(error)
    } */
  }

  const submit = async (values: FormData) => {
    try {
      setLoading(true)
      setUserData({username: values.username, password: values.password})
      const data_user = await getClientsFromUser(values,fingerprint)
      const login_data = {
        clients:data_user?.clients,
        /* username: values.username,
        password: values.password, */
        /* client_id: data_user?.data.clients[0].client_id,
        application_id: data_user?.data.clients[0].application_id,
        user_id: data_user?.data.user.id, */
        visitorId: fingerprint,
      }
      if (data_user && data_user.more_of_one === false) {
        login(login_data)
          .then(() => {
            setLoading(false)
          })
          .catch((error) => {
            setLoading(false)
            handle_error(error)
          })
      } else if (data_user && (data_user.more_of_one === true || true)) {
        setLoading(false)
        setMultipleClient(true)

        setClients(
          data_user.clients.map((item: any) => ({
            ...item,
            fullname: `${item?.client?.long_name}, ${item?.application?.long_name}`,
          }))
        )
      }
    } catch (error) {
      handle_error(error)
      setLoading(false)
    }
  }

  const submitClients = async (values: FormDataClient) => {
    try {
      setLoading(true)
      const { user } = values
      const client = clients.find((cli) => cli.id === user)
      const login_data = {
        /* username: values.username,
        password: values.password, */
        clients,
        client_id: client.client_id,
        /* application_id: client.application_id,
        user_id: client.user_id, */
        visitorId: fingerprint,
      }
      login(login_data)
        .then(() => {
          setLoading(false)
        })
        .catch((error) => {
          setLoading(false)
          handle_error(error)
        })
    } catch (error) {
      handle_error(error)
      setLoading(false)
    }
  }

  const notifyError = (error: any) => {
    try {
      const translatedMessageKey =
        typeof error === 'string'
          ? error
          : typeof error === 'undefined' || !error.message
          ? 'ra.auth.sign_in_error'
          : error.message

      const translatedMessage = translate(translatedMessageKey) || translatedMessageKey

      notify(translatedMessage, {
        type: 'warning',
        messageArgs: {
          _: translatedMessage,
        },
      })
    } catch (err) {
      console.error('Error while translating or notifying:', err)
    }
  }

  const handle_error = (error: any) => {
    try {
      if (error.message == DEVICE_NOT_FOUND) {
        setShowDeviceCodeField(true)
      } else if (error.message === DEVICE_WITH_EXPIRED_SESSION || error.message === INVALID_CODE) {
        setShowDeviceCodeField(true)
        notifyError(error)
      } else if (error.message == RESET_PASSWORD_USER) {
        sign_in_to_different_account()
        notifyError(error)
      } else if (error.message == USER_DISBLE) {
        sign_in_to_different_account()
        notifyError(error)
      } else if(error.message === EXPIRED_CODE){
        notifyError(error)
      } else {
        notify(DEFAULT_MSG, {
          type: 'warning'
        })
      }
    } catch (error) {}
  }

  const sign_in_to_different_account = () => {
    setClients([])
    setLoading(false)
    setUserData({})
    setMultipleClient(false)
    setShowDeviceCodeField(false)
    setFormKey((prev) => prev + 1) 
  }

  const submitWithCode = async (values: FormDataCode) => {
    try {
      setLoading(true)
      const data_user = await getClientsFromUser({...userData,...values},fingerprint)
      const login_data = {
        /* ...userData, */
        clients:data_user?.clients,
        device_code: values.device_code,
        visitorId: fingerprint,
      }
      login(login_data)
        .then(() => {
          setLoading(false)
        })
        .catch((error) => {
          setLoading(false)
          handle_error(error)
        })
    } catch (error) {
      handle_error(error)
      setLoading(false)
    }
  }

  if (showDeviceCodeField) {
    return (
      <>
        <StyledForm
          onSubmit={submitWithCode as any}
          key={formKey}
          mode='onChange'
          noValidate
          className={className}
          sx={{ width: '400px' }}
        >
          <CardContent className={LoginFormClasses.content} style={{ width: '100%' }}>
            <Typography variant='body1' sx={{ fontWeight: 'bold', textAlign: 'center', marginBottom: 2 }}>
              {translate('ra.auth.check_your_inbox')}
            </Typography>
            <Typography variant='body2' sx={{ textAlign: 'center', marginBottom: 3 }}>
              {translate('ra.auth.enter_device_code')}
            </Typography>
            <TextInput
              autoFocus
              source='device_code'
              label={translate('ra.auth.device_code')}
              validate={required()}
              fullWidth
            />

            <Button
              variant='contained'
              type='submit'
              color='primary'
              disabled={loading}
              fullWidth
              className={LoginFormClasses.button}
            >
              {loading ? (
                <CircularProgress className={LoginFormClasses.icon} size={19} thickness={3} />
              ) : (
                translate('ra.auth.login')
              )}
            </Button>

            <Button
              variant='contained'
              color='primary'
              disabled={loading}
              onClick={sign_in_to_different_account}
              fullWidth
              className={LoginFormClasses.recoverButton}
            >
              {translate('ra.auth.sign_in_to_different_account')}
            </Button>
          </CardContent>
        </StyledForm>
      </>
    )
  }
  return (
    <>
      {multipleClient ? (
        <StyledForm
          onSubmit={submitClients as any}
          mode='onChange'
          noValidate
          className={className}
          sx={{ width: '500px' }}
        >
          <CardContent className={LoginFormClasses.content} style={{ width: '100%' }}>
            <EditInputsWrap
              label={translate('ra.title.select_client_and_app')}
              required
              tooltiptext={undefined}
              disabled={undefined}
              xs={undefined}
              md={undefined}
              lg={undefined}
              style={undefined}
            >
              <SelectInput
                source='user'
                options={clients || undefined}
                label={null}
                validate={required()}
                fullWidth
                defaultValue={undefined}
                onChange={undefined}
                optionsText={['fullname']}
                helperText={undefined}
              />
            </EditInputsWrap>
            <Button
              variant='contained'
              type='submit'
              color='primary'
              disabled={loading}
              fullWidth
              className={LoginFormClasses.button}
            >
              {loading ? (
                <CircularProgress className={LoginFormClasses.icon} size={19} thickness={3} />
              ) : (
                translate('ra.auth.login')
              )}
            </Button>
          </CardContent>
        </StyledForm>
      ) : (
        <StyledForm onSubmit={submit as any} mode='onChange' noValidate className={className}>
          <CardContent className={LoginFormClasses.content}>
            <TextInput
              autoFocus
              source='username'
              label={translate('ra.auth.username')}
              validate={required()}
              fullWidth
            />
            <TextInput
              source='password'
              label={translate('ra.auth.password')}
              type='password'
              autoComplete='current-password'
              validate={required()}
              fullWidth
            />

            <Button
              variant='contained'
              type='submit'
              color='primary'
              disabled={loading}
              fullWidth
              className={LoginFormClasses.button}
            >
              {loading ? (
                <CircularProgress className={LoginFormClasses.icon} size={19} thickness={3} />
              ) : (
                translate('ra.auth.login')
              )}
            </Button>

            <Button
              variant='contained'
              href='#/recover'
              color='primary'
              disabled={loading}
              fullWidth
              className={LoginFormClasses.recoverButton}
            >
              {translate('ra.auth.recover_password')}
            </Button>
          </CardContent>
        </StyledForm>
      )}
    </>
  )
}

const PREFIX = 'RaLoginForm'

export const LoginFormClasses = {
  content: `${PREFIX}-content`,
  button: `${PREFIX}-button`,
  recoverButton: `${PREFIX}-recover-button`,
  icon: `${PREFIX}-icon`,
}

const StyledForm = styled(Form, {
  name: PREFIX,
  overridesResolver: (props, styles) => styles.root,
})(({ theme }) => ({
  [`& .${LoginFormClasses.content}`]: {
    width: 300,
  },
  [`& .${LoginFormClasses.button}`]: {
    marginTop: theme.spacing(2),
  },
  [`& .${LoginFormClasses.button}`]: {
    marginTop: theme.spacing(2),
  },
  [`& .${LoginFormClasses.recoverButton}`]: {
    marginTop: theme.spacing(5),
  },
  [`& .${LoginFormClasses.icon}`]: {
    margin: theme.spacing(0.3),
  },
}))

export interface LoginFormProps {
  redirectTo?: string
  className?: string
}

interface FormData {
  username: string
  password: string
}

interface FormDataClient {
  username: string
  password: string
  user: number
}

interface FormDataCode {
  device_code: string
}

LoginForm.propTypes = {
  redirectTo: PropTypes.string,
}
